/*
 * Application Insights JavaScript SDK - Web, 2.8.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
export var STR_EMPTY = "";
export var STR_SNIPPET = "snippet";
export var STR_GET_COOKIE_MGR = "getCookieMgr";
export var STR_START_TRACK_PAGE = "startTrackPage";
export var STR_STOP_TRACK_PAGE = "stopTrackPage";
export var STR_FLUSH = "flush";
export var STR_START_TRACK_EVENT = "startTrackEvent";
export var STR_STOP_TRACK_EVENT = "stopTrackEvent";
export var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
export var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
export var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
export var STR_GET_PLUGIN = "getPlugin";
export var STR_EVT_NAMESPACE = "evtNamespace";
export var STR_TRACK_EVENT = _TRACK + "Event";
export var STR_TRACK_TRACE = _TRACK + "Trace";
export var STR_TRACK_METRIC = _TRACK + "Metric";
export var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
export var STR_TRACK_EXCEPTION = _TRACK + "Exception";
export var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
export var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
export var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;
//# sourceMappingURL=InternalConstants.js.map